import { firestore } from "config/firebase/firebase";

export const DefaultContactPhone = () => firestore.collection("deliveryConfig").doc("contactPhone")

export const DeliveriesSettings = () => firestore.collection("deliveryConfig").doc("current");
export const UrgentDeliveriesEnabled = () => firestore.collection("deliveryConfig").doc("urgentDisabled");
export const SameDayDeliveriesEnabled = () => firestore.collection("deliveryConfig").doc("sameDayDisabled");
